const ENABLE_DEBUG = (process.env.REACT_APP_ENABLE_DEBUG === 'true');

function formatArgs(level, args) {
  const ts = new Date().toISOString();
  return [`[${ts}] [${level.toUpperCase()}]`, ...args];
}

export function info(...args) {
  console.info(...formatArgs('info', args));
}

export function warn(...args) {
  console.warn(...formatArgs('warn', args));
}

export function error(...args) {
  console.error(...formatArgs('error', args));
}

export function debug(...args) {
  if (!ENABLE_DEBUG) return;
  console.debug(...formatArgs('debug', args));
}

export default {
  info,
  warn,
  error,
  debug
};
